import React, { useEffect, useState } from 'react';

function ProductSearch({
  addProduct,
  translations,
  clearEntriesWithoutSerialnumber,
  restoreSearchTerm,
  restoreSearchResults,
  restoreSearchTrigger,
  setRestoreSearchResults,
  onProductAdd,
}) {
  const [searchResult, setSearchResult] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const countryCode = window._THULEDATA.SitecoreLanguage;
  const searchHitsDesktop = 20;
  const searchUrl = `/api/sitecore/SalesforceProductRegistration/SearchProducts?query=${searchInput}&numberOfResults=${searchHitsDesktop}&language=${countryCode}&imageSize=480`;
  const getSearchProducts = () => {
    const options = {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
    };
    fetch(searchUrl, { ...options, credentials: 'same-origin' })
      .then((response) => response.json())
      .then((data) => {
        if (data.length > 0) {
          setSearchResult(data);
          setShowSearchResults(true);
        } else {
          setSearchResult([]);
        }
        setRestoreSearchResults(data.length > 0 ? data : []);
        clearEntriesWithoutSerialnumber();
      })
      .catch((e) => e);
  };

  useEffect(() => {
    if (searchInput && searchInput.length >= 3) {
      const timer = setTimeout(() => {
        getSearchProducts();
      }, 500);
      return () => clearTimeout(timer);
    } else {
      setShowSearchResults(false);
    }
  }, [searchInput]);

  // Restore search term and trigger search when requested
  useEffect(() => {
    if (restoreSearchTrigger && restoreSearchTerm && restoreSearchTerm.length >= 3) {
      setSearchInput(restoreSearchTerm);
      // Immediate search
      if (restoreSearchResults.length > 0) {
        setSearchResult(restoreSearchResults);
        setShowSearchResults(true);
      } else {
        getSearchProducts();
      }
    }
  }, [restoreSearchTrigger]);

  return (
    <div className="sfpr__productSearch col-12">
      <form
        autoComplete="off"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <label htmlFor="tbProductName">{translations.FindYourProduct}</label>
        <div className="sfpr__findProduct sfpr__inputField">
          <i className="fas fa-search"></i>
          <input
            autoFocus
            onChange={(e) => setSearchInput(e.target.value)}
            className="d-block"
            placeholder={translations.SearchAllProducts}
            type="text"
            id="tbProductName"
            value={searchInput}
          ></input>
        </div>
      </form>
      {showSearchResults && (
        <div className="productSearch__results">
          <span className="productSearch__resultsLabel">
            {translations.Results} ({searchResult.length})
          </span>
          {searchResult.map(function (val) {
            return (
              <div
                className="productSearch__result"
                key={val.PimId}
                onClick={() => {
                  addProduct(val);
                  if (onProductAdd) onProductAdd(searchInput);
                  setSearchInput('');
                }}
              >
                {val.ProductImage ? (
                  <img alt={val.Name} src={val.ProductImage} />
                ) : (
                  <div className="image-placeholder"></div>
                )}
                <span>
                  {val.Name}
                  {val.Webtitle2 && ' - ' + val.Webtitle2}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default ProductSearch;
